import * as React from "react";
import { Spinner } from "@fluentui/react-components";
import { centered } from "../styles";

export interface TFwLoaderProps {
  label: string;
}

const FwLoader: React.FC<TFwLoaderProps> = (props: TFwLoaderProps) => {
  return (
    <div style={{ ...centered, height: "100vh" }}>
      <Spinner style={{ textAlign: "center" }} label={props.label} labelPosition="below" />
    </div>
  );
};

export default FwLoader;
